import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Box, Stack, Image, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getUrl} from '../../../utils/cloudinary-utils'
import {useGlobaleContext} from '../../../contexts/globale'
import useTagManager from '../../../hooks/use-tag-manager'
const Callout = ({product}) => {
    const {countryISO} = useGlobaleContext()
    const tagManager = useTagManager()
    const intl = useIntl()
    const textStyle = {
        display: 'flex',
        gap: '10px',
        alignItems: 'baseline',
        fontSize: '14px',
        lineHeight: '22px',
        letterSpacing: '0.07px',
        fontWeight: '300',
        color: 'black.100'
    }
    const iconWrapperStyles = {
        width: '15px',
        flex: '0 0 15px',
        transform: 'translateY(3px)'
    }

    useEffect(() => {
        if (product?.c_pdpShippingMessage && countryISO === 'US' && product.c_pdpShippingMessage) {
            tagManager.purchasePathMessage({
                productID: product?.id,
                productName: product?.name,
                productCategory: product?.c_primaryCategory,
                messageType: 'product_specific',
                messageText: product.c_pdpShippingMessage
            })
        }
    }, [product?.c_pdpShippingMessage, countryISO, product?.id])

    useEffect(() => {
        if (product?.id) {
            tagManager.purchasePathMessage({
                productID: product?.id,
                productName: product?.name,
                productCategory: product?.c_primaryCategory,
                messageType: 'product_specific',
                messageText: intl.formatMessage({
                    id: 'product_callout.gifting_made_easy_add_our_complimentary_gift_box_at_checkout',
                    defaultMessage: 'Gifting made easy. Add our complimentary gift box at checkout.'
                })
            })

            if (product?.c_isCustomizeBadgeActive && product?.c_colorBarAsset) {
                tagManager.purchasePathMessage({
                    productID: product?.id,
                    productName: product?.name,
                    productCategory: product?.c_primaryCategory,
                    messageType: 'product_specific',
                    messageText: product.c_colorBarAsset
                })
            }
        }
    }, [product?.id, product?.c_colorBarAsset])

    useEffect(() => {
        if (product?.c_isReturnable && countryISO === 'US' && product?.c_pdpReturnsMessage) {
            tagManager.purchasePathMessage({
                productID: product?.id,
                productName: product?.name,
                productCategory: product?.c_primaryCategory,
                messageType: 'product_specific',
                messageText: `${product?.c_pdpReturnsMessage?.replace(/<[^>]+>/g, '')?.trim()}`
            })
        }
    }, [countryISO, product?.id])

    return (
        <Stack
            padding="15px"
            spacing="10px"
            backgroundColor="white"
            borderRadius="10px"
            border="1px solid"
            borderColor="gray.400"
            fontSize={{base: '13px', lg: '14px'}}
            lineHeight="22px"
            className="sfcc-callouts"
            letterSpacing="0.07px"
            fontWeight="300"
            color="black.100"
        >
            {product?.c_pdpShippingMessage && countryISO === 'US' && (
                <Text {...textStyle} className="shipping-text">
                    <Box as="span" {...iconWrapperStyles} className="shipping-box">
                        <Image
                            width="15px"
                            className="shipping-image"
                            height="15px"
                            alt="Promotion Icon"
                            src={getUrl('UIImages/images/promotion-free-shipping.svg')}
                        />
                    </Box>
                    {product.c_pdpShippingMessage}
                </Text>
            )}

            {product?.c_isReturnable && countryISO === 'US' && product?.c_pdpReturnsMessage && (
                <Text {...textStyle} className="returns-text">
                    <Box as="span" {...iconWrapperStyles} className="returns-box">
                        <Image
                            width="15px"
                            height="15px"
                            className="returns-image"
                            alt="Return Policy Icon"
                            src={getUrl('UIImages/images/free-return.svg')}
                        />
                    </Box>
                    <Box
                        dangerouslySetInnerHTML={{__html: product?.c_pdpReturnsMessage}}
                        className="returns-html-box"
                        onClick={(e) => {
                            if (e.target.tagName === 'A') {
                                tagManager.pdpCtaClick(
                                    `cta click - ${e.target.innerText}`,
                                    product?.name
                                )
                            }
                        }}
                        sx={{
                            a: {
                                textUnderlineOffset: '4px',
                                textDecoration: 'underline',
                                transition: 'color 0.3s ease-in-out',
                                _hover: {
                                    color: 'blue.700'
                                }
                            }
                        }}
                    />
                </Text>
            )}

            {product?.c_pdpGiftMessage && (
                <Text {...textStyle} className="gifting-text">
                    <Box as="span" {...iconWrapperStyles} className="gifting-box">
                        <Image
                            width="15px"
                            className="gifting-image"
                            height="15px"
                            alt="Free Gift Icon"
                            src={getUrl('UIImages/images/gift.svg')}
                        />
                    </Box>
                    {product?.c_pdpGiftMessage}
                </Text>
            )}
            {product?.c_isCustomizeBadgeActive && product?.c_colorBarAsset && (
                <Box
                    className="colorbar-box"
                    dangerouslySetInnerHTML={{__html: product.c_colorBarAsset}}
                />
            )}
        </Stack>
    )
}

Callout.propTypes = {
    product: PropTypes.object
}

export default Callout
